
export default class BankAccountObligateResponseModel {
    public depositFundBalance: number = 0;
    public obligationFundBalance: number = 0;
    public obligationFundId: number = 0;
}
